var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g6, _path18, _path19, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageHistoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1797_2943",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 63,
    height: 62
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32C49.1208 0 63 13.8792 63 31V31C63 48.1208 49.1208 62 32 62H0V0Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1797_2943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.19276e-10 5.77802C0 2.58691 2.58691 0 5.77802 2.19461e-10L92.5731 3.51612e-09C94.2355 3.57926e-09 95.8174 0.716028 96.9144 1.96508L299.247 232.336C301.329 234.707 301.125 238.31 298.787 240.429L263.021 272.863L217.52 314.047C215.122 316.218 211.409 315.997 209.285 313.557L1.42003 74.7816C0.50437 73.7298 2.74691e-09 72.3823 2.69399e-09 70.9877L2.19276e-10 5.77802Z",
    fill: "#3388FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 10.2706C58 7.35972 60.3597 5 63.2706 5L134.57 5C136.088 5 137.533 5.65502 138.534 6.79721L305.93 197.848C307.823 200.009 307.637 203.288 305.511 205.221L276.177 231.886L238.8 265.797C236.611 267.783 233.218 267.582 231.28 265.35L59.2912 67.3113C58.4585 66.3525 58 65.1252 58 63.8553L58 10.2706Z",
    fill: "#7FB5FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1797_2943",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 64,
    height: 62
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000488281 0H31.9995C49.1203 0 62.9995 13.8792 62.9995 31V31C62.9995 48.1208 49.1203 62 31.9995 62H-0.000488281V0Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1797_2943)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1797_2943)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1797_2943)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41064 41.0288V10.6306C8.41064 9.40441 9.25959 8.41431 10.3109 8.41431H44.6229C45.6686 8.41431 46.5175 9.40441 46.5175 10.6306V41.0288C46.5175 42.2484 45.6686 43.2451 44.6229 43.2451H10.3109C9.25959 43.2451 8.41064 42.2484 8.41064 41.0288Z",
    fill: "#DAEAFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1797_2943",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 39,
    height: 32
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5176 39.5132V13.3299C46.5176 10.6151 44.3168 8.41431 41.602 8.41431H10.2893C9.8008 8.41431 9.36686 8.64213 9.04362 8.97939C8.63617 9.40451 8.85318 10.0549 9.31701 10.4176L46.5176 39.5132Z",
    fill: "#3388FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1797_2943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.41064 41.0288V10.6306C8.41064 9.40441 9.25959 8.41431 10.3109 8.41431H44.6229C45.6686 8.41431 46.5175 9.40441 46.5175 10.6306V41.0288C46.5175 42.2484 45.6686 43.2451 44.6229 43.2451H10.3109C9.25959 43.2451 8.41064 42.2484 8.41064 41.0288Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1797_2943",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 22,
    width: 44,
    height: 30
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.455 38.7443V35.2084C28.489 35.2084 28.5231 35.2019 28.5571 35.2019H29.3681C30.7122 35.2019 31.8067 36.4637 31.8067 38.0214V41.8398L32.5667 42.7205V37.9556C32.5667 37.8833 32.5724 37.811 32.578 37.7387V24.0553C32.578 22.9972 33.3153 22.1428 34.2284 22.1428C35.1415 22.1428 35.8788 22.9972 35.8788 24.0553V33.1316C36.1396 33.0659 36.4005 33.0199 36.6727 33.0067V29.9572C36.6727 28.8991 37.41 28.0447 38.3231 28.0447C39.2305 28.0447 39.9734 28.8991 39.9734 29.9572V32.9936H40.7674V31.6989C40.7674 30.6473 41.5104 29.7863 42.4178 29.7863C43.3309 29.7863 44.0681 30.6407 44.0681 31.6989V33.0067C44.346 33.0265 44.6126 33.0725 44.8735 33.1513C45.0776 32.3627 45.7071 31.7843 46.4501 31.7843C47.3632 31.7843 48.1004 32.6387 48.1004 33.6968V37.9556V42.7074V46.0263C48.1004 47.6957 47.3915 49.1679 46.3026 50.0683L35.72 50.8044C35.0281 50.5875 34.4042 50.1734 33.8995 49.6148L28.438 43.4237V38.7377C28.4437 38.7377 28.4493 38.7377 28.455 38.7443Z",
    fill: "#EDF4FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34521 33.8459L6.36038 31.1907H6.33202L7.39256 28.483L8.334 26.0118L8.35668 26.025L8.37937 25.9658L15.1169 26.0841C15.1169 26.1367 15.1226 26.1893 15.1226 26.2484L15.1055 27.5497C15.0772 29.7054 13.5459 31.4208 11.6857 31.3879L10.9485 31.3616L9.90495 34.9895C12.0204 36.7969 13.4495 40.2539 13.4495 44.2169C13.4495 47.2599 12.6045 50.0005 11.2547 51.9327H5.3679V33.8591L5.34521 33.8459Z",
    fill: "#EDF4FC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1797_2943)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.0283,
    y: 19,
    width: 99.8038,
    height: 78.6501,
    rx: 4.93299,
    fill: "#AFD0FE"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7632 12.3999H11.8359V39.4142H42.7632V12.3999Z",
    fill: "#5C656F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1797_2943",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 32,
    height: 28
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7632 12.4001H11.8359V39.4144H42.7632V12.4001Z",
    fill: "#D8DDE1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1797_2943)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1797_2943)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1797_2943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3806 47.5992H16.4092C16.0558 47.5992 15.7695 47.245 15.7695 46.8076V15.4429C15.7695 15.0056 16.0558 14.6514 16.4092 14.6514H38.3806C38.734 14.6514 39.0203 15.0056 39.0203 15.4429V46.8076C39.0203 47.245 38.734 47.5992 38.3806 47.5992Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.3806 14.6514H16.4092C16.0558 14.6514 15.7695 15.0056 15.7695 15.4429V20.6623H39.0202V15.4429C39.0202 15.0056 38.734 14.6514 38.3806 14.6514Z",
    fill: "#D8DDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.036 31.7605H33.9814V32.661H37.036V31.7605Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.036 34.9121H33.9814V35.8126H37.036V34.9121Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0358 17.3528H30.5449V18.2533H37.0358V17.3528Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0358 22.7556H30.5449V23.6561H37.0358V22.7556Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4357 22.7556H17.9448V23.6561H24.4357V22.7556Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4357 25.9072H17.9448V26.8077H24.4357V25.9072Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3085 31.7605H17.9448V32.661H31.3085V31.7605Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3448 34.9121H17.9448V35.8126H26.3448V34.9121Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.036 38.0637H33.9814V38.9642H37.036V38.0637Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6357 38.0637H17.9448V38.9642H28.6357V38.0637Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M38.3806 47.0591C38.7341 47.0591 39.0203 46.7107 39.0203 46.2805V15.43C39.0203 14.9998 38.7341 14.6514 38.3806 14.6514L27.3945 14.6514V47.0591C31.0566 47.0591 34.7186 47.0591 38.3806 47.0591Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1797_2943",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 22,
    width: 44,
    height: 30
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.455 38.7443V35.2084C28.489 35.2084 28.5231 35.2019 28.5571 35.2019H29.3681C30.7122 35.2019 31.8067 36.4637 31.8067 38.0214V41.8398L32.5667 42.7205V37.9556C32.5667 37.8833 32.5724 37.811 32.578 37.7387V24.0553C32.578 22.9972 33.3153 22.1428 34.2284 22.1428C35.1415 22.1428 35.8788 22.9972 35.8788 24.0553V33.1316C36.1396 33.0659 36.4005 33.0199 36.6727 33.0067V29.9572C36.6727 28.8991 37.41 28.0447 38.3231 28.0447C39.2305 28.0447 39.9734 28.8991 39.9734 29.9572V32.9936H40.7674V31.6989C40.7674 30.6473 41.5104 29.7863 42.4178 29.7863C43.3309 29.7863 44.0681 30.6407 44.0681 31.6989V33.0067C44.346 33.0265 44.6126 33.0725 44.8735 33.1513C45.0776 32.3627 45.7071 31.7843 46.4501 31.7843C47.3632 31.7843 48.1004 32.6387 48.1004 33.6968V37.9556V42.7074V46.0263C48.1004 47.6957 47.3915 49.1679 46.3026 50.0683L35.72 50.8044C35.0281 50.5875 34.4042 50.1734 33.8995 49.6148L28.438 43.4237V38.7377C28.4437 38.7377 28.4493 38.7377 28.455 38.7443Z",
    fill: "#EDF4FC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34521 33.8459L6.36038 31.1907H6.33202L7.39256 28.483L8.334 26.0118L8.35668 26.025L8.37937 25.9658L15.1169 26.0841C15.1169 26.1367 15.1226 26.1893 15.1226 26.2484L15.1055 27.5497C15.0772 29.7054 13.5459 31.4208 11.6857 31.3879L10.9485 31.3616L9.90495 34.9895C12.0204 36.7969 13.4495 40.2539 13.4495 44.2169C13.4495 47.2599 12.6045 50.0005 11.2547 51.9327H5.3679V33.8591L5.34521 33.8459Z",
    fill: "#EDF4FC"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1797_2943)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 31,
    y: 28,
    width: 81,
    height: 61,
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.2
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5176 39.5132V13.3299C46.5176 10.6151 44.3168 8.41431 41.602 8.41431H10.2961C9.48418 8.41431 8.81328 9.03628 8.54492 9.81376L46.5176 39.5132Z",
    fill: "white"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1447 43.2451H7.33691V72.4781H19.1447V43.2451Z",
    fill: "#DEC1AE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2226 40.5065V36.9706C31.2566 36.9706 31.2906 36.9641 31.3247 36.9641H32.1357C33.4798 36.9641 34.5743 38.2259 34.5743 39.7836V43.602L35.3343 44.4827V39.7178C35.3343 39.6455 35.34 39.5732 35.3456 39.501V25.8176C35.3456 24.7594 36.0829 23.905 36.996 23.905C37.9091 23.905 38.6463 24.7594 38.6463 25.8176V34.8938C38.9072 34.8281 39.1681 34.7821 39.4403 34.7689V31.7194C39.4403 30.6613 40.1776 29.8069 41.0907 29.8069C41.9981 29.8069 42.741 30.6613 42.741 31.7194V34.7558H43.535V33.4611C43.535 32.4095 44.2779 31.5485 45.1854 31.5485C46.0984 31.5485 46.8357 32.4029 46.8357 33.4611V34.7689C47.1136 34.7887 47.3801 34.8347 47.641 34.9135C47.8452 34.1249 48.4747 33.5465 49.2177 33.5465C50.1307 33.5465 50.868 34.4009 50.868 35.459V39.7178V44.4696V47.7885C50.868 49.4579 50.1591 50.9301 49.0702 51.8305V95.7265H38.4875V52.5666C37.7956 52.3497 37.1718 51.9356 36.667 51.377L31.2056 45.1859V40.4999C31.2112 40.4999 31.2169 40.4999 31.2226 40.5065Z",
    fill: "#DEC1AE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33747 35.6892L8.35949 33.034H8.33094L9.39864 30.3262L10.3464 27.8551L10.3693 27.8682L10.3921 27.8091L17.1751 27.9274C17.1751 27.98 17.1808 28.0325 17.1808 28.0917L17.1637 29.393C17.1352 31.5487 15.5936 33.264 13.7208 33.2312L12.9786 33.2049L11.928 36.8328C14.0577 38.6401 15.4965 42.0971 15.4965 46.0602C15.4965 49.1031 14.6002 53.425 13.2413 55.3573H7.3374L7.33747 35.6892Z",
    fill: "#EFD0BB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3635 55.3572H6.87256V133.743H13.3635V55.3572Z",
    fill: "#3388FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8542 55.3572H13.3633V133.743H19.8542V55.3572Z",
    fill: "#1760CE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1797_2943",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 24,
    width: 10,
    height: 81
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3844 24.7988H43.834V104.81H52.3844V24.7988Z",
    fill: "#3388FF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1797_2943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0552 40.5065V36.9706C31.0895 36.9706 31.1238 36.9641 31.1581 36.9641H31.9756C33.3303 36.9641 34.4335 38.2259 34.4335 39.7836V43.602L35.1995 44.4827V39.7178C35.1995 39.6455 35.2052 39.5732 35.211 39.501V25.8176C35.211 24.7594 35.9541 23.905 36.8744 23.905C37.7947 23.905 38.5378 24.7594 38.5378 25.8176V34.8938C38.8008 34.8281 39.0637 34.7821 39.3381 34.7689V31.7194C39.3381 30.6613 40.0812 29.8069 41.0015 29.8069C41.9161 29.8069 42.6649 30.6613 42.6649 31.7194V34.7558H43.4652V33.4611C43.4652 32.4095 44.214 31.5485 45.1286 31.5485C46.049 31.5485 46.7921 32.4029 46.7921 33.4611V34.7689C47.0722 34.7887 47.3408 34.8347 47.6038 34.9135C47.8096 34.1249 48.4441 33.5465 49.1929 33.5465C50.1132 33.5465 50.8563 34.4009 50.8563 35.459V39.7178V44.4696V47.7885C50.8563 49.4579 50.1418 50.9301 49.0443 51.8305V95.7265H38.3778V52.5666C37.6804 52.3497 37.0516 51.9356 36.5428 51.377L31.0381 45.1859V40.4999C31.0438 40.4999 31.0495 40.4999 31.0552 40.5065Z",
    fill: "#EFD0BB"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9089 55.3572H37.7998V133.743H43.9089V55.3572Z",
    fill: "#1760CE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3996 55.3572H43.9087V133.743H50.3996V55.3572Z",
    fill: "#3388FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1797_2943",
    x: -3.12744,
    y: 8.41431,
    width: 53.9956,
    height: 132.329,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1797_2943"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1797_2943",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1797_2943",
    x: 2.87256,
    y: 8.41431,
    width: 51.9956,
    height: 133.329,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1797_2943"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1797_2943",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1797_2943",
    x: 15.7695,
    y: 14.6514,
    width: 23.251,
    height: 37.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.17722
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1797_2943"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1797_2943",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1797_2943",
    x: 13.7695,
    y: 14.6514,
    width: 25.2505,
    height: 34.9478,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1797_2943"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1797_2943",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageHistoryIcon);
export default __webpack_public_path__ + "static/media/message_history_icon.ef6575a1.svg";
export { ForwardRef as ReactComponent };